import moment from 'moment'

import { getTimeLeftObject } from 'utils/dateTime.utils'

import { ROOT_URL } from 'constants/general.constants'
import { MONTHS, getMonthsLabel } from '@elo-kit/constants/dateTime.constants'
import { getPayerSellerLink } from '@elo-kit/utils/helpers.utils'
import { getElopageConfig } from 'utils/elopageConfig.utils'

export const getTooltipTimestamp = (date) => {
  const month = moment(date).format('MM')
  const day = moment(date).format('DD')
  const monthAndDayLabel = getMonthsLabel(day)[MONTHS[Number(month) - 1]]
  const formattedMonthAndDayLabel = monthAndDayLabel?.split(',')?.join(' ')
  const yearAndHoursLabel = moment(date).format('YYYY, HH:mm')

  return `${formattedMonthAndDayLabel}, ${yearAndHoursLabel}`
}

export const getFormattedCreatedTime = (createdTime) => {
  const { weeks, days, hours, minutes, seconds } = getTimeLeftObject(createdTime, true)

  if (days > 0 || weeks > 0) {
    return getTooltipTimestamp(createdTime)
  } else if (hours > 0 || minutes > 10) {
    return moment(createdTime).format('HH:mm')
  } else {
    if (minutes > 5 && minutes <= 10) {
      return `${I18n.t('react.shared.community.time.mins_ago', { number: 10 })}`
    }
    if (minutes > 1 && minutes <= 5) {
      return `${I18n.t('react.shared.community.time.mins_ago', { number: 5 })}`
    }
    if (seconds > 2 && minutes <= 1) {
      return I18n.t('react.shared.community.time.min_ago')
    }
  }

  return '1s'
}

export const getCommunityDeepLink = ({ seller, productSlug, communityId }) => {
  const { host, username } = seller
  const webHost = getElopageConfig('webHost')
  const isCustomDomain = host !== webHost
  return getPayerSellerLink(
    {
      seller: isCustomDomain && seller,
      sellerName: username,
      slug: `courses/${productSlug}?community_id=${communityId}`,
    },
    ROOT_URL
  )
}
